"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { cn } from "@/lib/utils";
import type { TechLogo } from "./technologies";
export type TechnologyCardProps = {
  logo?: TechLogo;
  className?: string;
  "aria-hidden"?: boolean;
};
export function TechnologyCard(t0) {
  const $ = _c(10);
  const {
    logo,
    className,
    "aria-hidden": ariaHidden
  } = t0;
  if (!logo) {
    return null;
  }
  const t1 = `tech-card flex w-full py-7 md:py-11 items-center justify-center rounded-2xl  
        bg-[#7979791A] transition-colors duration-300 ${className ?? ""}`;
  const t2 = logo.alt;
  let t3;
  if ($[0] !== logo.className) {
    t3 = cn("tech-card-icon mx-auto h-auto w-full object-contain will-change-transform", logo.className);
    $[0] = logo.className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== logo.alt || $[3] !== logo.image || $[4] !== t3) {
    t4 = <div className="relative flex w-full items-center justify-center overflow-hidden"><Image alt={t2} className={t3} height={2000} src={logo.image} width={2000} /></div>;
    $[2] = logo.alt;
    $[3] = logo.image;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ariaHidden || $[7] !== t1 || $[8] !== t4) {
    t5 = <div aria-hidden={ariaHidden} className={t1}>{t4}</div>;
    $[6] = ariaHidden;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}